import { Controller } from "@hotwired/stimulus";
import { Offcanvas } from "bootstrap";

export default class extends Controller {
  connect() {
    this.element.removeAttribute("data-controller");
    Offcanvas.getOrCreateInstance(this.element).show();
  }
}
